import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });
export const partnerApi = axios.create({ baseURL: API });

export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("ap_admin_token", token);
  } else {
    delete api.defaults.headers.common["Authorization"];
    localStorage.removeItem("ap_admin_token");
  }
};

export const loadAuthToken = () => {
  const t = localStorage.getItem("ap_admin_token");
  if (t) api.defaults.headers.common["Authorization"] = `Bearer ${t}`;
  return t;
};

export const setPartnerToken = (token) => {
  if (token) {
    partnerApi.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("ap_partner_token", token);
  } else {
    delete partnerApi.defaults.headers.common["Authorization"];
    localStorage.removeItem("ap_partner_token");
  }
};

export const loadPartnerToken = () => {
  const t = localStorage.getItem("ap_partner_token");
  if (t) partnerApi.defaults.headers.common["Authorization"] = `Bearer ${t}`;
  return t;
};

export const fileDownloadUrl = (fileId, token) =>
  `${API}/admin/files/${fileId}/download?auth=${encodeURIComponent(token)}`;

export const partnerFileUrl = (fileId, token) =>
  `${API}/retailer/files/${fileId}/download?auth=${encodeURIComponent(token)}`;
